/* SLUMBER NAV — keyboard navigation + accordion coordination.
   Open/close mechanics, hover trigger, Escape-close, focusout-close and
   click-outside-close all come from the theme's custom elements
   (mega-menu-disclosure, navigation-drawer, accordion-disclosure). This file
   adds only what they don't provide:
   - roving arrow-key navigation across the desktop menubar (Left/Right/Home/End)
   - ArrowDown opens a mega menu and moves focus into it; ArrowUp/Down walk it
   - focus returns to the trigger when Escape closes a mega menu
   - single-open behavior for mega menus and drawer accordions
   Uses the `open` property (not attribute removal) so the elements' close
   animations run. */
(function () {
  'use strict';

  var nav = document.querySelector('.snv-nav');

  function menubarItems() {
    return Array.prototype.slice.call(nav.querySelectorAll('[data-snv-menubar-item]'));
  }

  function panelLinks(details) {
    var panel = details.querySelector('.snv-mega');
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll('a[href]')).filter(function (link) {
      return link.offsetParent !== null;
    });
  }

  if (nav) {
    /* Only one mega menu open at a time */
    nav.addEventListener('toggle', function (event) {
      var details = event.target.closest('.snv-megadetails');
      if (!details || !details.open) return;
      nav.querySelectorAll('.snv-megadetails[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    }, true);

    nav.addEventListener('keydown', function (event) {
      var items = menubarItems();
      var index = items.indexOf(document.activeElement);
      var openDetails = event.target.closest('.snv-megadetails[open]');

      /* Escape in an open mega menu: the theme element closes it; we restore
         focus to the trigger so keyboard users aren't dropped. */
      if (event.key === 'Escape' && openDetails) {
        var summary = openDetails.querySelector('summary');
        openDetails.open = false;
        if (summary) summary.focus();
        return;
      }

      /* Menubar-level keys */
      if (index !== -1) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          var next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = items.length - 1;
          else if (event.key === 'ArrowRight') next = (index + 1) % items.length;
          else next = (index - 1 + items.length) % items.length;
          items[next].focus();
        } else if (event.key === 'ArrowDown' && event.target.matches('summary')) {
          event.preventDefault();
          var details = event.target.closest('.snv-megadetails');
          details.open = true;
          var links = panelLinks(details);
          if (links.length) links[0].focus();
        }
        return;
      }

      /* Inside an open panel: ArrowUp/ArrowDown walk the links */
      if (openDetails && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        var links2 = panelLinks(openDetails);
        var linkIndex = links2.indexOf(document.activeElement);
        if (linkIndex === -1) return;
        event.preventDefault();
        var nextLink = event.key === 'ArrowDown'
          ? (linkIndex + 1) % links2.length
          : (linkIndex - 1 + links2.length) % links2.length;
        links2[nextLink].focus();
      }
    });
  }

  /* Promo bar: rotate messages every 5s; pause on hover/focus; static under
     prefers-reduced-motion */
  var promo = document.querySelector('[data-snv-promo-rotate]');
  if (promo && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var msgs = Array.prototype.slice.call(promo.querySelectorAll('.snv-promo__msg'));
    if (msgs.length > 1) {
      var current = 0;
      var timer = null;
      var advance = function () {
        msgs[current].classList.remove('is-active');
        msgs[current].setAttribute('aria-hidden', 'true');
        msgs[current].setAttribute('tabindex', '-1');
        current = (current + 1) % msgs.length;
        msgs[current].classList.add('is-active');
        msgs[current].removeAttribute('aria-hidden');
        msgs[current].removeAttribute('tabindex');
      };
      var start = function () {
        if (!timer) timer = setInterval(advance, 5000);
      };
      var stop = function () {
        clearInterval(timer);
        timer = null;
      };
      promo.addEventListener('mouseenter', stop);
      promo.addEventListener('mouseleave', start);
      promo.addEventListener('focusin', stop);
      promo.addEventListener('focusout', start);
      start();
    }
  }

  /* Support status: compute open/closed in the support timezone and reveal
     the status pills (desktop popover + mobile drawer) */
  document.querySelectorAll('[data-snv-status]').forEach(function (el) {
    try {
      var tz = el.getAttribute('data-tz') || 'America/Los_Angeles';
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour: 'numeric',
        hourCycle: 'h23',
        weekday: 'short'
      }).formatToParts(new Date());
      var hour = null;
      var weekday = '';
      parts.forEach(function (part) {
        if (part.type === 'hour') hour = parseInt(part.value, 10);
        if (part.type === 'weekday') weekday = part.value;
      });
      if (hour === null) return;
      var start = parseInt(el.getAttribute('data-start'), 10);
      var end = parseInt(el.getAttribute('data-end'), 10);
      var weekdaysOnly = el.getAttribute('data-weekdays') === 'true';
      var isWeekend = weekday === 'Sat' || weekday === 'Sun';
      var open = hour >= start && hour < end && !(weekdaysOnly && isWeekend);
      el.classList.add(open ? 'is-open' : 'is-closed');
      var text = el.querySelector('[data-snv-status-text]');
      if (text) text.textContent = el.getAttribute(open ? 'data-open-text' : 'data-closed-text') || '';
      el.hidden = false;
    } catch (error) {
      /* leave the pill hidden if timezone math fails */
    }
  });

  /* Live chat: open the Gorgias widget when present; otherwise the row's
     href (help center) is the fallback */
  document.querySelectorAll('[data-snv-chat]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      var chat = window.GorgiasChat;
      if (chat && typeof chat.open === 'function') {
        event.preventDefault();
        chat.open();
      }
    });
  });

  /* Drawer: exclusive accordions — opening one closes its siblings */
  var drawer = document.getElementById('header-sidebar-menu');
  if (drawer && drawer.classList.contains('snv-drawer')) {
    drawer.addEventListener('toggle', function (event) {
      var details = event.target.closest('details[data-snv-exclusive]');
      if (!details || !details.open) return;
      drawer.querySelectorAll('details[data-snv-exclusive][open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
      /* the sibling that just auto-closed above removes its height from the
         scroll position, so the tapped section's options land off-screen.
         Let the collapse settle, then bring the opened section's header to
         the top of the drawer (scroll-margin in CSS supplies the offset). */
      window.setTimeout(function () {
        details.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }, 180);
    }, true);
  }

  /* Drawer entrance: replace the theme's serial timeline (host fade → 0.4s
     clip wipe → content fade ≈ 0.7s before items appear; the wipe is also
     neutralized by our corner-radius clip-path pin, leaving only a fade) with
     a single fast slide-in from the left. _showTransition/_hideTransition are
     the theme's documented custom-transition hooks on DialogElement; own
     properties survive custom-element upgrade, so assigning before sections.js
     defines navigation-drawer is safe. */
  if (drawer && drawer.classList.contains('snv-drawer') && 'animate' in drawer) {
    var SLIDE_EASE = 'cubic-bezier(0.32, 0.72, 0, 1)'; /* fast start, soft settle */
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var drawerContent = function () {
      return drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="content"]');
    };

    /* The theme's Motion timelines committed the resting inline styles the
       drawer relies on (visibility/opacity); ours must leave the same state. */
    var settle = function (open) {
      drawer.style.opacity = open ? '1' : '0';
      drawer.style.visibility = open ? 'visible' : 'hidden';
    };

    drawer._showTransition = function (animate) {
      if (typeof this._setInitialPosition === 'function') this._setInitialPosition();
      var content = drawerContent();
      this.style.visibility = 'visible';
      var run = [
        this.animate({ opacity: [0, 1] }, { duration: 120, easing: 'ease-out', fill: 'forwards' })
      ];
      if (content && !reduceMotion.matches) {
        run.push(content.animate(
          { transform: ['translateX(-100%)', 'translateX(0)'] },
          { duration: 320, easing: SLIDE_EASE, fill: 'forwards' }
        ));
      }
      if (animate === false) {
        run.forEach(function (a) { a.finish(); });
      }
      return Promise.all(run.map(function (a) { return a.finished; })).then(function () {
        run.forEach(function (a) { a.cancel(); });
        settle(true);
        drawer.classList.add('show-close-cursor');
      });
    };

    drawer._hideTransition = function () {
      var content = drawerContent();
      var run = [
        this.animate({ opacity: [1, 0] }, { duration: 200, easing: 'ease-in', fill: 'forwards' })
      ];
      if (content && !reduceMotion.matches) {
        run.push(content.animate(
          { transform: ['translateX(0)', 'translateX(-100%)'] },
          { duration: 220, easing: 'cubic-bezier(0.55, 0, 0.68, 0.19)', fill: 'forwards' }
        ));
      }
      return Promise.all(run.map(function (a) { return a.finished; })).then(function () {
        run.forEach(function (a) { a.cancel(); });
        settle(false);
        drawer.classList.remove('show-close-cursor');
      });
    };

    /* Speed pass: warm the drawer's lazy images once the page is idle so the
       first open never shows a white flash while photos fetch/decode. */
    var warmed = false;
    var warmDrawerImages = function () {
      if (warmed) return;
      warmed = true;
      drawer.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    };
    /* Idle-scheduled rather than load-gated: requestIdleCallback only fires
       when the browser is genuinely idle, so this can't compete with the LCP
       hero fetch, and it still runs early on pages whose load event is slow. */
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmDrawerImages, { timeout: 8000 });
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(warmDrawerImages, 1500);
      }, { once: true });
    }
    /* Belt and braces: a finger heading for the burger warms them immediately */
    document.querySelectorAll('[aria-controls="header-sidebar-menu"]').forEach(function (btn) {
      btn.addEventListener('pointerdown', warmDrawerImages, { once: true, passive: true });
    });
  }
})();
